<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html {
  font-size: 16px;
}
body {
  font-size: 14px;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue